export default __webpack_public_path__ + "static/media/kitchen3-afterG-480w.4ae062c8.png";